import { useMutation, useQueryClient } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { userQueryKeys } from '../QueryKeys';

export default function useUserNotificationsMutations() {
  const queryClient = useQueryClient();
  const { post } = useApiHelper();

  const acknowledge = useMutation({
    mutationFn: (notificationIds: string[]) =>
      post<{ notifications: string[] }, IDefaultResponseWithData<null>>(
        '/v1/user/notifications/acknowledge',
        { notifications: notificationIds }
      ),
    onSettled: () => {
      queryClient.invalidateQueries(userQueryKeys.notifications());
    },
  });

  return { acknowledge };
}
